export enum IvrProcessStatus {
  InProgress = 'InProgress',
  Completed = 'Completed',
  PendingApproval = 'PendingApproval',
  Failed = 'Failed',
  TimedOut = 'TimedOut',
}
